var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bootbox modal fade in show",staticStyle:{"display":"block"},attrs:{"tabindex":"-1","role":"dialog"}},[_c('div',{class:`modal-dialog ${_vm.popupClass}`},[_c('div',{staticClass:"modal-content",style:(_vm.cssValue)},[_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }